import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import { Box } from "@mui/material";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { toast } from "react-toastify";
import { Select, FormControl, InputLabel } from "@mui/material";
import { cambiarFinca, updateInstalacion, UpdateSale } from "../../../services";
import provinces from "@doncicuto/es-provinces";
import municipalities from "@doncicuto/es-municipalities";
import { ordenarProvinciasYMunicipios } from "../../../functions/ordenarListas";
import {
  municipiosIniciales,
  cambiarFormatoNombre,
  ventaMasReciente,
  GRUPOS_SERVICIO,
} from "../../../functions/funciones";
import LaeButton from "../../../components/Buttons/LaeButton";
import {
  verificarCorreo,
  verificarTelefono,
  verificarNif,
  verificarCodigoPostal,
} from "../../../functions/validator/formValidator";
import { CustomSwitch } from "../../../components/Buttons/Switch";
import { useNavigate } from "react-router-dom";
import { UsuarioContext } from "../../../providers/userContext";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "85ch",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
};

// Perfiles internos que pueden habilitar o deshabilitar el QR de la comunidad
const PUEDE_EDITAR_QR = ["ADMIN", "CONSUL", "VENT"];

export default function TransitionsModal(props) {
  const { t } = useTranslation(['properties', 'common']);
  const user = useContext(UsuarioContext)
  const navigate = useNavigate();
  const [editarDatos, setEditarDatos] = useState({});
  const [listadoMunicipios, setListadoMunicipios] = useState([]);
  const [activo, setActivo] = useState(false);
  const [estados, setEstados] = useState([]);

  useEffect(() => {
    // Obtener estados del cache (localStorage)
    const estadosCache = JSON.parse(localStorage.getItem("states")) || [];
    setEstados(estadosCache);

    const sale_cae = ventaMasReciente(props.finca?.sales, GRUPOS_SERVICIO.cae);
    const sale_lopd = ventaMasReciente(props.finca?.sales, GRUPOS_SERVICIO.lopd);
    const sale_cai = ventaMasReciente(props.finca?.sales, GRUPOS_SERVICIO.cai);
    const instalacion_kae = props.finca?.instalacionesKae?.find(i => i.prop_id === props.finca.id) || null;
    const fincaData = {
      nif: props.finca.nif === null ? "" : props.finca.nif,
      razonSocial: props.finca.razonSocial === null ? "" : props.finca.razonSocial,
      email: props.finca.emailContacto === null ? "" : props.finca.emailContacto,
      nombre: props.finca.nombreContacto === null ? "" : props.finca.nombreContacto,
      telefono: props.finca.telefonoContacto === null ? "" : props.finca.telefonoContacto,
      municipio: props.finca.municipio === null ? "" : props.finca.municipio,
      direccion: props.finca.direccion === null ? "" : props.finca.direccion,
      codigoPostal: props.finca.codigoPostal === null ? "" : props.finca.codigoPostal,
      provincia: props.finca.provincia === null ? "" : props.finca.provincia,
      nifPresidente: props.finca.nifPresidente === null ? "" : props.finca.nifPresidente,
      nombrePresidente: props.finca.nombrePresidente === null ? "" : props.finca.nombrePresidente,
      activo: props.finca.activo === null ? true : props.finca.activo,
      proveedores: props.finca.proveedores === null ? true : props.finca.proveedores,
      ocultarSPA: props.finca.ocultarSPA === null ? false : props.finca.ocultarSPA,
      qrOmniaHogar: props.finca.qrOmniaHogar ?? false,
      estadoCae: sale_cae
        ? sale_cae.estado_id === null
          ? 1
          : sale_cae.estado_id
        : "-",
      estadoLopd: sale_lopd
        ? sale_lopd.estado_id === null
          ? 1
          : sale_lopd.estado_id
        : "-",
      estadoCai: sale_cai
        ? sale_cai.estado_id === null
          ? 1
          : sale_cai.estado_id
        : "-",
      estadoKae: instalacion_kae
        ? instalacion_kae.estado_id === null
          ? 1
          : instalacion_kae.estado_id
        : "-",
      saleCae_id: sale_cae?.id || null,
      saleLopd_id: sale_lopd?.id || null,
      saleCai_id: sale_cai?.id || null,
      instalacionKae_id: instalacion_kae?.id || null,
    };
    setEditarDatos(fincaData);
    setListadoMunicipios(
      municipiosIniciales(provinces, municipalities, props.finca.provincia)
    );
  }, [props]);
  function handleChange(evt) {
    const { name, type, checked, value } = evt.target;

    if (name === "qrOmniaHogar") {
      setEditarDatos({
        ...editarDatos,
        qrOmniaHogar: value === "omnia",
      });
    } else if (name === "activo" || name === "proveedores" || name === "ocultarSPA") {
      setEditarDatos({
        ...editarDatos,
        [name]: checked,
      });
    } else {
      setEditarDatos({
        ...editarDatos,
        [name]: value,
      });
    }
  }

  const handleChangeEstado = (evt, id, serv) => {
    const valor = parseInt(evt.target.value);
    const sale_id =
      serv === "cae"
        ? editarDatos?.saleCae_id
        : serv === "lopd"
        ? editarDatos?.saleLopd_id
        : serv === "cai"
        ? editarDatos?.saleCai_id
        : serv === "kae"
        ? editarDatos?.instalacionKae_id
        : null;
    if (serv === "kae") {
      updateInstalacion(id, {
        estado_id: valor,
      });
    } else {
      UpdateSale(id, {
        estado_id: valor,
      });
    }
    const nuevosDatos =
      serv === "cae"
      ? { estadoCae: valor }
      : serv === "lopd"
      ? { estadoLopd: valor }
      : serv === "kae"
      ? { estadoKae: valor }
      : serv === "cai"
      ? { estadoCai: valor }
      : null;
    setEditarDatos({ ...editarDatos, estado_id: nuevosDatos });
  };

  const editar = (finca) => {
    setActivo(true);
    const toastInfo = toast.info(t('messages.saving'), { autoClose: false });

    const validarCampos = () => {
      let errores = false;
      const data = {
        emailContacto: finca.email,
        telefonoContacto: finca.telefono,
        codigoPostal: finca.codigoPostal,
        nifPresidente: finca.nifPresidente,
        direccion: finca.direccion,
        razonSocial: finca.razonSocial,
        nif: finca.nif,
        estado: finca.estado,
        activo: finca.activo,
        proveedores: finca.proveedores,
      };

      const requiredFields = ["telefonoContacto", "razonSocial"];

      requiredFields.forEach((field) => {
        if (!data[field]) {
          toast.dismiss(toastInfo);
          toast.error(t('common:technicians.messages.fieldRequired', { field }));
          errores = true;
        }
      });

      Object.keys(data).forEach((key) => {
        switch (key) {
          case "emailContacto":
            let correoCorrecto = verificarCorreo(data.emailContacto);
            if (correoCorrecto === false) {
              toast.dismiss(toastInfo);
              toast.error(t('messages.incorrectEmail'));
              errores = true;
            }
            break;
          // case "telefonoContacto":
          //   let telefonoCorrecto = verificarTelefono(data.telefonoContacto);
          //   if (telefonoCorrecto === false) {
          //     toast.dismiss(toastInfo);
          //     toast.error(t('messages.incorrectPhone'));
          //     errores = true;
          //   }
          //   break;
          case "codigoPostal":
            let codigoPostalCorrecto = verificarCodigoPostal(data.codigoPostal);
            if (codigoPostalCorrecto === false) {
              toast.dismiss(toastInfo);
              toast.error(t('messages.incorrectPostalCode'));
              errores = true;
            }
            break;
          case "nifPresidente":
            let nifPresidenteCorrecto = verificarNif(data.nifPresidente);
            if (nifPresidenteCorrecto === false && data.nifPresidente != "") {
              toast.dismiss(toastInfo);
              toast.error(t('messages.incorrectPresidentNif'));
              errores = true;
            }
            break;
          default:
            break;
        }
      });

      return errores;
    };

    const enviarSolicitudCambio = () => {
      cambiarFinca(props.finca.nif, {
        nif: finca.nif,
        razonSocial: finca.razonSocial,
        emailContacto: finca.email,
        nombreContacto: finca.nombre,
        telefonoContacto: finca.telefono,
        municipio: finca.municipio,
        direccion: finca.direccion,
        codigoPostal: finca.codigoPostal,
        provincia: finca.provincia,
        nifPresidente: finca.nifPresidente,
        nombrePresidente: finca.nombrePresidente,
        activo: finca.activo,
        proveedores: finca.proveedores,
        ocultarSPA: finca.ocultarSPA,
        // El backend solo acepta el cambio de QR desde perfiles internos
        ...(PUEDE_EDITAR_QR.includes(user.rol) && { qrOmniaHogar: finca.qrOmniaHogar }),
      })
        .then((res) => {
          if (res.status === 201) {
            toast.update(toastInfo, {
              render: t('messages.editSuccess'),
              type: toast.TYPE.SUCCESS,
              autoClose: true,
            });
            // Obtener la URL actual
            const urlActual = window.location.pathname + window.location.search;

            // Expresión regular para reemplazar solo el NIF en la parte correcta de la URL
            const nuevaUrl = urlActual.replace(
              new RegExp(`comunidades/${props.finca.nif}`), // Busca "comunidades/V95592511"
              `comunidades/${finca.nif}` // Reemplaza por "comunidades/V95592500"
            );

            // Cambiar la URL sin recargar la página
            navigate(nuevaUrl, { replace: true });
            props.handleClose();
          } else if (res.status === 403) {
            toast.update(toastInfo, {
              render: res.data.error[0],
              type: toast.TYPE.ERROR,
              autoClose: true,
            });
          } else {
            toast.update(toastInfo, {
              render: t('messages.editError'),
              type: toast.TYPE.ERROR,
              autoClose: true,
            });
          }
        })
        .catch((err) => {
          console.log(err);
          toast.update(toastInfo, {
            render: t('messages.editError'),
            type: toast.TYPE.ERROR,
            autoClose: true,
          });
        })
        .finally(() => {
          setActivo(false);
        });
    };

    const errores = validarCampos();

    if (!errores) {
      enviarSolicitudCambio();
    } else {
      setActivo(false);
    }
  };

  const seleccionarMunicipios = (e) => {
    let codProvincia = "";
    let municipios = [];
    provinces.map((p) => {
      if (p.name === e.target.value) {
        codProvincia = p.code;
      }
    });
    setEditarDatos({
      ...editarDatos,
      [e.target.name]: e.target.value,
    });
    municipalities.map((m) => {
      if (m.provCode === codProvincia) {
        municipios.push({
          ...m,
          name: cambiarFormatoNombre(m.name),
          value: m.name,
        });
      }
    });
    setListadoMunicipios(municipios);
  };

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        //className={modal}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        open={props.opened}
        onClose={props.handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Box sx={style}>
          <div
            /* className={paper} */ style={{
              backgroundColor: "#fff",
              border: "2px solid #000",
              boxShadow:
                "0px 3px 5px -1px rgba(0,0,0,0.2),0px 5px 8px 0px rgba(0,0,0,0.14),0px 1px 14px 0px rgba(0,0,0,0.12)",
              padding: "16px 32px 24px",
            }}
          >
            <h2 id="transition-modal-title">{t('edit.title')}</h2>
            <div id="transition-modal-description">
              <form noValidate autoComplete="off">
                <div
                  /* className={form} */ style={{
                    margin: "8px",
                    width: "100ch",
                    position: "relative",
                    display: "grid",
                    gridTemplateColumns: " repeat(2, 1fr)",
                    gridGap: "15px",
                    fontSize: "12px",
                  }}
                >
                  <TextField
                    id="nif"
                    name="nif"
                    label={t('common:form.nif')}
                    value={editarDatos.nif}
                    onChange={handleChange}
                  />
                  <TextField
                    id="razonSocial"
                    name="razonSocial"
                    label={t('edit.fields.businessName')}
                    value={editarDatos.razonSocial}
                    onChange={handleChange}
                  />
                  <TextField
                    id="email"
                    name="email"
                    label={t('common:form.email')}
                    value={editarDatos.email}
                    onChange={handleChange}
                  />
                  <TextField
                    id="nombre"
                    name="nombre"
                    label={t('common:form.name')}
                    value={editarDatos.nombre}
                    onChange={handleChange}
                  />
                  <TextField
                    id="telefono"
                    name="telefono"
                    label={t('common:form.phone')}
                    value={editarDatos.telefono}
                    onChange={handleChange}
                  />
                  <TextField
                    id="direccion"
                    name="direccion"
                    label={t('common:form.address')}
                    value={editarDatos.direccion}
                    onChange={handleChange}
                  />
                  <TextField
                    id="codigoPostal"
                    name="codigoPostal"
                    label={t('common:form.postalCode')}
                    value={editarDatos.codigoPostal}
                    onChange={handleChange}
                  />
                  <FormControl>
                    <InputLabel shrink htmlFor="provincia">{t('common:form.province')}</InputLabel>
                    <Select
                    native
                    notched
                    label={t('common:form.province')}
                    name="provincia"
                    id="provincia"
                    style={{ textTransform: "uppercase" }}
                    onChange={seleccionarMunicipios}
                    defaultValue={editarDatos?.provincia}
                  >
                    <option value="">{t('common:form.province')}</option>
                    {provinces
                      .sort(ordenarProvinciasYMunicipios)
                      ?.map((e, i) => {
                        return (
                          <option key={i} value={e.name}>
                            {e.name}
                          </option>
                        );
                      })}
                  </Select>
                  </FormControl>
                  <FormControl>
                    <InputLabel shrink htmlFor="municipio">{t('common:form.city')}</InputLabel>
                    <Select
                    native
                    notched
                    label={t('common:form.city')}
                    name="municipio"
                    id="municipio"
                    style={{ textTransform: "uppercase" }}
                    onChange={handleChange}
                    defaultValue={editarDatos?.municipio}
                  >
                    <option value="">{t('common:form.city')}</option>
                    {listadoMunicipios
                      .sort(ordenarProvinciasYMunicipios)
                      ?.map((e, i) => {
                        return (
                          <option key={i} value={e.value}>
                            {e.name}
                          </option>
                        );
                      })}
                  </Select>
                  </FormControl>
                  <TextField
                    id="nifPresidente"
                    name="nifPresidente"
                    label={t('edit.fields.presidentNif')}
                    value={editarDatos.nifPresidente}
                    onChange={handleChange}
                  />
                  <TextField
                    id="nombrePresidente"
                    name="nombrePresidente"
                    label={t('edit.fields.presidentName')}
                    value={editarDatos.nombrePresidente}
                    onChange={handleChange}
                  />
                  {user.rol === "TECH" || user.rol === "TECH_COOR" ? null :
                  editarDatos?.saleCae_id === null ? (
                    <TextField label={t('edit.fields.caeStatus')} value={"-"} />
                  ) : (
                    <FormControl>
                    <InputLabel shrink htmlFor="estadoCae">{t('edit.fields.caeStatus')}</InputLabel>
                    <Select
                      label={t('edit.fields.caeStatus')}
                      native
                      notched
                      name="estadoCae"
                      id="estadoCae"
                      style={{
                        textTransform: "uppercase",
                        color:
                          editarDatos?.estadoCae === 1 || null
                            ? "#3eae3e"
                            : editarDatos?.estadoCae === 2 ||
                              editarDatos?.estadoCae === 3
                            ? "#FF8300"
                            : editarDatos?.estadoCae === 4 || editarDatos?.estadoCae === 5
                            ? "#EE4534"
                            : "#000",
                      }}
                      onChange={(event) =>
                        handleChangeEstado(
                          event,
                          editarDatos?.saleCae_id,
                          "cae"
                        )
                      }
                      defaultValue={editarDatos?.estadoCae}
                    >
                      {estados?.map((e, i) => {
                        return (
                          <option
                            key={i}
                            value={e.id}
                            style={{
                              color:
                                e.id === 1 || e.id == null
                                  ? "#3eae3e"
                                  : e.id === 2 || e.id === 3
                                  ? "#FF8300"
                                  : e.id === 4 || e.id === 5
                                  ? "#EE4534"
                                  : "#000",
                            }}
                          >
                            {t(`common:stateNames.${e.nombre}`, e.nombre)}
                          </option>
                        );
                      })}
                    </Select>
                    </FormControl>
                  )}
                  {user.rol === "TECH" || user.rol === "TECH_COOR" ? null :
                  editarDatos?.saleLopd_id === null ? (
                    <TextField label={t('edit.fields.lopdStatus')} value={"-"} />
                  ) : (
                    <FormControl>
                    <InputLabel shrink htmlFor="estadoLopd">{t('edit.fields.lopdStatus')}</InputLabel>
                    <Select
                      label={t('edit.fields.lopdStatus')}
                      native
                      notched
                      name="estadoLopd"
                      id="estadoLopd"
                      // disabled = {editarDatos?.saleLopd_id === null ? 'disabled' : 'enabled'}
                      style={{
                        textTransform: "uppercase",
                        color:
                          editarDatos?.estadoLopd === 1 || null
                            ? "#3eae3e"
                            : editarDatos?.estadoLopd === 2 ||
                              editarDatos?.estadoLopd === 3
                            ? "#FF8300"
                            : editarDatos?.estadoLopd === 4 || editarDatos?.estadoLopd === 5
                            ? "#EE4534"
                            : "#000",
                      }}
                      onChange={(event) =>
                        handleChangeEstado(
                          event,
                          editarDatos?.saleLopd_id,
                          "lopd"
                        )
                      }
                      defaultValue={editarDatos?.estadoLopd}
                    >
                      {estados?.map((e, i) => {
                        return (
                          <option
                            key={i}
                            value={e.id}
                            style={{
                              color:
                                e.id === 1 || e.id == null
                                  ? "#3eae3e"
                                  : e.id === 2 || e.id === 3
                                  ? "#FF8300"
                                  : e.id === 4 || e.id === 5
                                  ? "#EE4534"
                                  : "#000",
                            }}
                          >
                            {t(`common:stateNames.${e.nombre}`, e.nombre)}
                          </option>
                        );
                      })}
                    </Select>
                    </FormControl>
                  )}
                  {PUEDE_EDITAR_QR.includes(user.rol) && (
                    <FormControl>
                    <InputLabel shrink htmlFor="qrOmniaHogar">{t('edit.fields.qrAccess')}</InputLabel>
                    <Select
                      label={t('edit.fields.qrAccess')}
                      native
                      notched
                      name="qrOmniaHogar"
                      id="qrOmniaHogar"
                      value={editarDatos.qrOmniaHogar ? "omnia" : "cae"}
                      onChange={handleChange}
                    >
                      <option value="cae">{t('edit.fields.qrAccessCae')}</option>
                      <option value="omnia">{t('edit.fields.qrAccessOmnia')}</option>
                    </Select>
                    </FormControl>
                  )}
                  {user.rol === "TECH" || user.rol === "TECH_COOR" ? null :
                  editarDatos?.saleCai_id === null ? (
                    <TextField label={t('edit.fields.caiStatus')} value={"-"} />
                  ) : (
                    <FormControl>
                    <InputLabel shrink htmlFor="estadoCai">{t('edit.fields.caiStatus')}</InputLabel>
                    <Select
                      label={t('edit.fields.caiStatus')}
                      native
                      notched
                      name="estadoCai"
                      id="estadoCai"
                      style={{
                        textTransform: "uppercase",
                        color:
                          editarDatos?.estadoCai === 1 || null
                            ? "#3eae3e"
                            : editarDatos?.estadoCai === 2 ||
                              editarDatos?.estadoCai === 3
                            ? "#FF8300"
                            : editarDatos?.estadoCai === 4 || editarDatos?.estadoCai === 5
                            ? "#EE4534"
                            : "#000",
                      }}
                      onChange={(event) =>
                        handleChangeEstado(
                          event,
                          editarDatos?.saleCai_id,
                          "cai"
                        )
                      }
                      defaultValue={editarDatos?.estadoCai}
                    >
                      {estados
                        ?.filter((e) => ["Activa", "Baja", "Anulado"].includes(e.nombre))
                        .map((e, i) => {
                          return (
                            <option
                              key={i}
                              value={e.id}
                              style={{
                                color:
                                  e.id === 1 || e.id == null
                                    ? "#3eae3e"
                                    : e.id === 2 || e.id === 3
                                    ? "#FF8300"
                                    : e.id === 4 || e.id === 5
                                    ? "#EE4534"
                                    : "#000",
                              }}
                            >
                              {t(`common:stateNames.${e.nombre}`, e.nombre)}
                            </option>
                          );
                        })}
                    </Select>
                    </FormControl>
                  )}
                  {user.rol === "TECH" || user.rol === "TECH_COOR" ? null :
                  editarDatos?.saleKae_id === null ? (
                    <TextField label={t('edit.fields.kaeStatus')} value={"-"} />
                  ) : (
                    <FormControl>
                    <InputLabel shrink htmlFor="estadoKae">{t('edit.fields.kaeStatus')}</InputLabel>
                    <Select
                      label={t('edit.fields.kaeStatus')}
                      native
                      notched
                      name="estadoKae"
                      id="estadoKae"
                      style={{
                        textTransform: "uppercase",
                        color:
                          editarDatos?.estadoKae === 1 || null
                            ? "#3eae3e"
                            : editarDatos?.estadoKae === 2 ||
                              editarDatos?.estadoKae === 3
                            ? "#FF8300"
                            : editarDatos?.estadoKae === 4 || editarDatos?.estadoKae === 5
                            ? "#EE4534"
                            : "#000",
                      }}
                      onChange={(event) =>
                        handleChangeEstado(
                          event,
                          editarDatos?.instalacionKae_id,
                          "kae"
                        )
                      }
                      defaultValue={editarDatos?.estadoKae}
                    >
                      {estados
                        ?.filter((e) => ["Activa", "Baja", "Anulado"].includes(e.nombre))
                        .map((e, i) => {
                          return (
                            <option
                              key={i}
                              value={e.id}
                              style={{
                                color:
                                  e.id === 1 || e.id == null
                                    ? "#3eae3e"
                                    : e.id === 2 || e.id === 3
                                    ? "#FF8300"
                                    : e.id === 4 || e.id === 5
                                    ? "#EE4534"
                                    : "#000",
                              }}
                            >
                              {t(`common:stateNames.${e.nombre}`, e.nombre)}
                            </option>
                          );
                        })}
                    </Select>
                    </FormControl>
                  )}
                  {user.rol === "TECH" || user.rol === "TECH_COOR" ? null :
                    <div style={{ gridColumn: "span 2" }}>
                      {/* <h7>Activo</h7>
                      <CustomSwitch
                        name="activo"
                        checked={editarDatos.activo}
                        onChange={handleChange}
                      /> */}
                      <h7>{t('edit.fields.suppliers')}</h7>
                      <CustomSwitch
                        name="proveedores"
                        checked={editarDatos.proveedores}
                        onChange={handleChange}
                      />
                      {/* <h7>{t('edit.fields.hideSPA')}</h7>
                      <CustomSwitch
                        name="ocultarSPA"
                        checked={editarDatos.ocultarSPA}
                        onChange={handleChange}
                      /> */}
                    </div>
                  }
                </div>
                <div
                  /* className={form} */ style={{
                    margin: "8px",
                    width: "100ch",
                    position: "relative",
                    display: "grid",
                    gridTemplateColumns: " repeat(2, 1fr)",
                    gridGap: "15px",
                    fontSize: "12px",
                  }}
                >
                  <Button
                    variant="contained"
                    sx={{
                      flex: 1,
                      backgroundColor: "whitesmoke",
                      color: "#92004D",
                      ":hover": { backgroundColor: "#92004D", color: "white" },
                      margin: 0,
                      p: 1,
                    }}
                    disableElevation
                    onClick={props.handleClose}
                  >
                    {t('common:actions.cancel')}
                  </Button>
                  <LaeButton
                    sx={{ flex: 1 }}
                    onClick={() => editar(editarDatos)}
                  >
                    {t('common:actions.save')}
                  </LaeButton>
                </div>
              </form>
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
}
